import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { IconLibrary } from '@finnairoyj/fcom-ui-styles/enums';
import { Observable } from 'rxjs';

import { CmsArticle } from '@fcom/core-api/';
import { FragmentService } from '@fcom/common/services';
import { ModalButtons } from '@fcom/ui-components';

@Component({
  selector: 'fin-sustainability-trip-message',
  templateUrl: './sustainability-trip-message.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SustainabilityTripMessageComponent implements OnInit {
  @Input() fragmentKey: string;

  @Input() iconCategory: IconLibrary = IconLibrary.SVG_LIBRARY;

  @Input() linkText: string;

  modalOpen = false;

  tripMessage$: Observable<CmsArticle>;

  readonly ModalButtons = ModalButtons;

  constructor(private fragmentService: FragmentService) {}

  ngOnInit(): void {
    this.tripMessage$ = this.fragmentService.getFragment<CmsArticle>(this.fragmentKey);
  }

  openModal(): void {
    this.modalOpen = true;
  }

  closeModal(): void {
    this.modalOpen = false;
  }
}
